var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-toggle-button.ts
import { acss } from "@adornis/chemistry/directives/acss";
import "@adornis/chemistry/elements/components/x-flex";
import { FormField } from "@adornis/forms/form-field";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "./../fonts";
var GEToggleButton = class extends FormField {
  constructor() {
    super(...arguments);
    this.label = "";
  }
  render() {
    if (!this.label)
      return this.knob();
    return html`
      <x-flex horizontal crossaxis-center space="sm">
        <ge-text> ${this.label} </ge-text>
        ${this.knob()}
      </x-flex>
    `;
  }
  knob() {
    return html`
      <x-flex
        horizontal
        ${acss({
      border: `1px solid ${this.colors.accent}`,
      "x-flex": { cursor: "pointer", color: this.colors.accent },
      "x-flex[active]": { background: this.colors.accent, color: this.colors.on.accent }
    })}
      >
        <x-flex
          padding="sm"
          ?active=${this.value.value}
          @click=${() => {
      this.value.next(true);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: true } }));
    }}
        >
          <ge-text> YES </ge-text>
        </x-flex>
        <x-flex
          padding="sm"
          ?active=${!this.value.value}
          @click=${() => {
      this.value.next(false);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: false } }));
    }}
        >
          <ge-text> NO </ge-text>
        </x-flex>
      </x-flex>
    `;
  }
};
__decorateClass([
  property({ reflect: true })
], GEToggleButton.prototype, "label", 2);
GEToggleButton = __decorateClass([
  customElement("ge-toggle-button")
], GEToggleButton);
export {
  GEToggleButton
};
